  import React,{useEffect} from "react";
  import Navbar from "../components/Navbar/Navbar";
  import Projects from "../components/Projects/Projects";
  import Footer from "../components/Footer/Footer";

  const AllProjects = () => {

        useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return (
      <>
        <Navbar />
        <Projects /> {/* show ALL projects */}
        <Footer />
      </>
    );
  };

  export default AllProjects;
                